import React from 'react'
import { Col, Modal, Row } from 'antd'
import './DeleteFileTypeModal.scss'

const DeleteFileTypeModal = ({
  visible,
  onOk,
  onCancel,
  loading
}) => {
  return (
    <Modal
      title='Delete File Type'
      visible={visible}
      onOk={() => {
        onOk()
      }}
      onCancel={() => onCancel()}
      className='general-modal delete-file-type-modal'
      okButtonProps={{
        loading,
        disabled: loading
      }}
      centered
    >
      <Row gutter={[24, 24]}>
        <Col span={24}>
          Are you sure you want to delete ?
        </Col>
      </Row>
    </Modal>
  )
}

export default DeleteFileTypeModal
